import Button from 'react-bootstrap/Button';

export default function CartDomain(props) {
  const remove = (e) => {
    e.preventDefault();
    props.removeDomain(props.domain);
  }

  return (
    <tr key={props.domain}>
      <td>{props.domain}</td>
      <td><Button variant="primary my-3" onClick={remove}>Remove</Button></td>
    </tr>
  )
}
